import React, { FC } from 'react'
import { StaticQuery, graphql } from "gatsby"

import { StoryblokEventForm } from "./StoryblokEventForm"

interface IForm {
  isDark: boolean
  formUuid: string
  campaign_id: Array<{ label: string; value: string }>
  campaign_id_label: string
  multi_campaign: boolean
}

const Form: FC<IForm> = ({
  isDark,
  formUuid,
  campaign_id,
  campaign_id_label,
  multi_campaign
}) => (
  <StaticQuery
    query={graphql`
      query {
        allStoryblokEntry(
          filter: { full_slug: { regex: "/^hult/config/events/" } }
        ) {
          edges {
            node {
              uuid
              content
            }
          }
        }
      }
    `}

    render={(data) => {
      let form: any

      if (data && data.allStoryblokEntry) {
        data.allStoryblokEntry.edges.filter((e: { node: { uuid: React.Key | null | undefined; content: string } }) => {
          if (e.node.uuid === formUuid) {
            const block = JSON.parse(e.node.content)
            return (form = (
              <StoryblokEventForm
                multi_campaign={multi_campaign}
                isDark={isDark}
                key={e.node.uuid}
                blok={block}
                campaign_id={campaign_id}
                campaign_id_label={campaign_id_label}
              />
            ))
          }
          return form
        })
      }
      return form
    }}
  />
)

export default Form